import DashboardViews from "./dashboardviews";
import SidebarComponent from "./sidebar";

function DashboardPage() {
  return (
    <div className="flex">
      <SidebarComponent />
      <DashboardViews />
    </div>
  );
}

export default DashboardPage;
